var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5,
    r: 8,
    stroke: "#E82B27",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20312 13.6429C9.20313 13.8702 9.29343 14.0882 9.45418 14.2489C9.61492 14.4097 9.83294 14.5 10.0603 14.5C10.2876 14.5 10.5056 14.4097 10.6664 14.2489C10.8271 14.0882 10.9174 13.8702 10.9174 13.6429C10.9174 13.4155 10.8271 13.1975 10.6664 13.0368C10.5056 12.876 10.2876 12.7857 10.0603 12.7857C9.83294 12.7857 9.61492 12.876 9.45418 13.0368C9.29343 13.1975 9.20313 13.4155 9.20312 13.6429ZM9.6317 11.6429H10.4888C10.5674 11.6429 10.6317 11.5786 10.6317 11.5V6.64286C10.6317 6.56429 10.5674 6.5 10.4888 6.5H9.6317C9.55313 6.5 9.48884 6.56429 9.48884 6.64286V11.5C9.48884 11.5786 9.55313 11.6429 9.6317 11.6429Z",
    fill: "#E82B27"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f83aefcf8e160a09b2a4382b13e465f6.svg";
export { ForwardRef as ReactComponent };